export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'I am Developer',
  heading:
    'Hi! my name is Niraj Srivastava and I am a Full-stack Web Developer',
  description:
    'Aspiring MERN stack developer.Recently graduated with a B.tech in Computer Science and Engineering.Passionate about creating efficient and scalable web applications.Dedicated to delivering high-quality code and collaborating with cross-functional teams to drive project success. Eager to contribute expertise in full-stack development to innovative projects.',
  buttonLabel: 'What I do',
  imgStart: false,
  primary: true,
  dark: true,
  darkText: false,
};
